/**
 * \@docs-private
 */
var AnimationCurves = (function () {
    function AnimationCurves() {
    }
    AnimationCurves.STANDARD_CURVE = 'cubic-bezier(0.4,0.0,0.2,1)';
    AnimationCurves.DECELERATION_CURVE = 'cubic-bezier(0.0,0.0,0.2,1)';
    AnimationCurves.ACCELERATION_CURVE = 'cubic-bezier(0.4,0.0,1,1)';
    AnimationCurves.SHARP_CURVE = 'cubic-bezier(0.4,0.0,0.6,1)';
    return AnimationCurves;
}());
export { AnimationCurves };
function AnimationCurves_tsickle_Closure_declarations() {
    /** @type {?} */
    AnimationCurves.STANDARD_CURVE;
    /** @type {?} */
    AnimationCurves.DECELERATION_CURVE;
    /** @type {?} */
    AnimationCurves.ACCELERATION_CURVE;
    /** @type {?} */
    AnimationCurves.SHARP_CURVE;
}
/**
 * \@docs-private
 */
var AnimationDurations = (function () {
    function AnimationDurations() {
    }
    AnimationDurations.COMPLEX = '375ms';
    AnimationDurations.ENTERING = '225ms';
    AnimationDurations.EXITING = '195ms';
    return AnimationDurations;
}());
export { AnimationDurations };
function AnimationDurations_tsickle_Closure_declarations() {
    /** @type {?} */
    AnimationDurations.COMPLEX;
    /** @type {?} */
    AnimationDurations.ENTERING;
    /** @type {?} */
    AnimationDurations.EXITING;
}
//# sourceMappingURL=animation.js.map